<script setup lang="ts">
import CardContainer from '@/components/Card/card-container.vue'
import CardHeaderItem from '@/components/Card/card-header-item.vue'
import CardHeader from '@/components/Card/card-header.vue'
import CardContent from '@/components/Card/card-content.vue'
import { QuillEditor } from '@vueup/vue-quill'

const content = defineModel<string | null>('content')
</script>

<template>
  <CardContainer>
    <CardHeader>
      <CardHeaderItem>Notes</CardHeaderItem>
    </CardHeader>
    <CardContent>
      <QuillEditor
        theme="snow"
        :options="{ placeholder: 'Please type notes here.' }"
        v-model:content="content"
        content-type="html"
        :toolbar="['bold', 'italic', 'underline', { list: 'ordered' }, { list: 'bullet' }]"
      />
    </CardContent>
  </CardContainer>
</template>

<style module lang="scss">
@import "@/assets/variables";

:global(.ql-editor) {
  font-family: $font-family-sans-serif;
  font-size: $font-size-base;
}
</style>
